/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import { FieldSlider } from '@blockly/field-slider';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.ARDUINOUNO_salidas_led_brillo_planetario = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Led.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendValueInput('DATOIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField('del led');
    this.appendDummyInput().appendField('de la cúpula');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_TOOLTIP);
  },
};

Blockly.Blocks.ARDUINOUNO_salidas_led_brillo_planetario2 = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Led.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().appendField('Apagar todas las luces de la cúpula');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_TOOLTIP);
  },
};

Blockly.Blocks.ARDUINOUNO_salidas_led_brillo_planetario_clear = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Led.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('DATOIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField('Apagar el led');
    this.appendDummyInput().appendField('de la cúpula');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LED_TOOLTIP);
  },
};

Blockly.Blocks.BHOOT_led_neopixel_planetario = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/11.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField('del segmento');
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        ['1', '0'], ['2', '1'], ['3', '2'], ['4', '3'], ['5', '4'],
        ['6', '5'], ['7', '6'], ['8', '7'], ['9', '8'], ['10', '9'],
      ]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField('de la cúpula');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};

Blockly.Blocks.BHOOT_led_neopixel_clear_planetario = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/11.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('').appendField('Apagar el segmento');
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        ['1', '0'], ['2', '1'], ['3', '2'], ['4', '3'], ['5', '4'],
        ['6', '5'], ['7', '6'], ['8', '7'], ['9', '8'], ['10', '9'],
      ]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField('de la cúpula');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};

// Comparte matriz/definiciones con matriz_ciudad_planetario para no duplicar `Max72xxPanel matrix`
// cuando ambos bloques conviven en un programa.
Blockly.Blocks.borrar_matriz_planetario = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/matriz_9_de_julio.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField('Borrar textos de pantalla');
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};

Blockly.Blocks.matriz_ciudad_planetario = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/matriz_9_de_julio.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('TEXTOIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.MATRIZ_CIUDAD_ESCRIBIR);
    this.appendValueInput('DATOIN')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.MATRIZ_CIUDAD_VELOCIDAD);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.MATRIZ_CIUDAD_TOOLTIP);
  },
};

// Shadow de posición para las luces de la cúpula (slider 1-60, un LED por posición).
Blockly.Blocks.math_number_reflector = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new FieldSlider(60, 1, 60, 1), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
};

Blockly.Blocks.planetario_reflector = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/11.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField('del reflector');
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([['1', '0'], ['2', '1'], ['3', '2']]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};

Blockly.Blocks.planetario_reflector_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/Bhoot/11.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('').appendField('Apagar el reflector');
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([['1', '0'], ['2', '1'], ['3', '2']]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('').appendField('de la cúpula');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LEDRGB_TOOLTIP);
  },
};
